module.exports = __webpack_public_path__ + "static/media/gas.bef270c0.svg";